import React from "react";
import Sidebar from "./Sidebar";
import Header from "./Header";

const Brightcheck = () => {
  return (
    <>
      <div id="wrapper">
        <Sidebar />
        <div id="content-wrapper" className="d-flex flex-column">
          <div id="content">
            <Header />
            <div className="container-fluid">
              <div className="card shadow mb-4">
                <div className="card-header py-3">
                  <h6 className="m-0 font-weight-bold text-primary">
                    IDMtrust
                  </h6>
                </div>
                <div className="card-body">
                  <div style={{ paddingLeft: 10, paddingRight: 10 }}>
                    <div className="row mb-2 ">
                      <div className="col-md-7">
                        <div>
                          <input
                            type="text"
                            className="form-control search-input-new"
                            placeholder="Enter user, email, or phone number to search"
                            // value={searchData}
                            // onChange={searchList}
                          />
                        </div>
                        {/* {searchData.length >= 1 && ( */}
                        <div
                          // onClick={handleClearSearch}
                          className="cross-serach-new"
                        >
                          <i className="fa fa-times cursor-pointerr"></i>
                        </div>
                        {/* )} */}
                      </div>
                      <div className="col-md-2">
                        <button
                          className="btn btn-primary form-control"
                          //   onClick={handleSearch}
                          // onKeyDown={handleSearch}
                        >
                          Search
                        </button>
                      </div>
                      <div className="col-md-2">
                        <button
                          className="btn btn-primary form-control"
                          //   onClick={ExportExcel}
                          // disabled={this.state.loaders}
                        >
                          Export
                        </button>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-md-2 mt-2">
                        <select
                          className="form-select w100"
                          id="inlineFormSelectPref"
                          //   value={filterData}
                          //   onChange={(e) => filter(e)}
                        >
                          <option value="">All</option>
                          <option value={"verify"}>Eligible</option>
                          <option value={"non-verify"}>Non eligible</option>
                        </select>
                      </div>

                      <div className="col-md-3 mt-2">
                        <select
                          className="form-select w100"
                          id="inlineFormSelectPref"
                          //   value={default_page}
                          //   onChange={(e) => filter2(e)}
                        >
                          <option value={""}>Select No of Rows</option>
                          <option value={10}>10</option>
                          <option value={25}>25</option>
                          <option value={50}>50</option>
                          <option value={100}>100</option>
                        </select>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Brightcheck;
